import { render, staticRenderFns } from "./edit_single_group.vue?vue&type=template&id=ecfab5e6&scoped=true&"
import script from "./edit_single_group.vue?vue&type=script&setup=true&lang=ts&"
export * from "./edit_single_group.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./edit_single_group.vue?vue&type=style&index=0&id=ecfab5e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfab5e6",
  null
  
)

export default component.exports